export default "__VITE_ASSET__$9mafoA9__"